import type { PublicBuildingAnalysis } from '@popety-io/types'

// Metadata-only sections from old shares must not mask actual saved arrays.
// An explicitly empty array, however, is a valid saved selection.
const firstArray = <T>(...values: unknown[]): T[] =>
  values.find((value): value is T[] => Array.isArray(value)) ?? []

export const getBuildingShareSavedItems = (
  value: Record<string, any>
): Pick<
  PublicBuildingAnalysis,
  | 'saved_transactions'
  | 'saved_building_permits'
  | 'purchase_listings'
  | 'rental_listings'
> => {
  const summary = value.summary
  return {
    saved_transactions: firstArray(
      value.saved_transactions,
      value.transactions,
      summary?.saved_transactions,
      summary?.transactions
    ),
    saved_building_permits: firstArray(
      value.saved_building_permits,
      value.building_permits,
      summary?.saved_building_permits,
      summary?.building_permits
    ),
    purchase_listings: firstArray(
      value.purchase_listings,
      summary?.purchase_listings
    ),
    rental_listings: firstArray(
      value.rental_listings,
      summary?.rental_listings
    ),
  }
}
